import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_COASTAL_SEGMENTS_LOCATIONS",
    parentId: "PILOT_COASTAL_SEGMENTS_VIEWS",
    applicationRights: Rights,
    title: 'Lokasjoner',
    text: 'Sertifikatomr&aring;ders lokasjoner',
    icon: 'map-pin',
    minWidth: 768,
    sequenceNo: 3000,
    url: "/pcs/LOCATIONS"
})
